import styled from 'styled-components';
import { svgs } from '../../../assets';

export const Caret = styled(svgs.FORWARD_CARET)`
  font-weight: 600;
  transform: ${({ show }) => (show === 'show' ? 'rotate(90deg)' : 'none')};
  transition: ease-in 0.5s;
`;
